import React, { useEffect } from 'react'
import './Styling/Home.css'
import { Link } from 'react-router-dom'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import memlogohome from '../Assets/Home/memlogohome.png'
import '../Assets/Home/memhomebg.png'
import avoidLegalTrouble from '../Assets/Home/avoidLegalTrouble.png'
import ensureCompliance from '../Assets/Home/establishRelationships.png'
import establishRelationships from '../Assets/Home/ensureCompliance.png'


const Home = () => {

    const location=useLocation();

    const { user, loginWithRedirect, logout, isAuthenticated } = useAuth0();
    const navigate = useNavigate();

    function accButton(){
        if (isAuthenticated) {
            return(
              <Link to="/account" className='tab'><p>Account</p></Link>
            );
        }else{
          return(<div></div>);
        }
      }

    function checkAuth(){
        if (isAuthenticated) {
            return "Sign Out"
        } else {
            return "Sign In"
        }
    }

    useEffect(() => {
      document.title = "MyEmployeeManual.com — State-Compliant Employee Handbooks";
    }, []);

    return (
        <div>
            <div className="homeHeader">
                <div className='homeNavbar'>
                    <div className='imgContainer'>
                        <Link to="/">
                            <img src={memlogohome} alt='MEM Logo' className="logo"/>
                        </Link>
                    </div>
                    <Link to="/" className='tab'><p>Home</p></Link>
                    <Link to="/contact" className='tab'><p>Contact Us</p></Link>
                    {accButton()}
                    <div className='navbarRight'>
                        <button onClick={() => isAuthenticated ? logout() : loginWithRedirect()} className='tab'><p>{checkAuth()}</p></button>
                    </div>
                </div>
                <div className='txt'>
                    <h1>Last year, the EEOC collected $699.7 million from U.S. employers.</h1>
                    <p>One in four employment lawsuits that reach a jury results in a judgment of $500,000 or more.<br /><br />A trustworthy employee manual is one of your best defenses.</p>
                    <p className='heroSource'><em>Sources: EEOC FY2024 Annual Performance Report; Hiscox Guide to Employee Lawsuits.</em></p>
                </div>
                <div className='buttons'>
                    <a href='#benefits'><button>Learn More</button></a>
                    <button className='getStarted' onClick={loginWithRedirect}>Get Started</button>
                    <a href='#pricing'><button>View Pricing</button></a>
                </div>
            </div>
            <div className='benefits' id='benefits'>
                <h1>Benefits</h1>
                <p>Why should your business have an employee manual?</p>
                <div className='benefitsList'>
                    <div className='benefitsCard'>
                        <h1>Facing an Audit or Complaint?</h1>
                        <p>When an EEOC charge, Labor Commissioner claim, or DOL audit lands on your desk, the first thing investigators ask for is your written policies. A current, jurisdiction-specific handbook is one of the strongest pieces of evidence you can put in front of them.</p>
                        <img src={avoidLegalTrouble} alt='Facing an Audit or Complaint?'/>
                    </div>
                    <div className='benefitsCard'>
                        <h1>Growing Past a Headcount Threshold?</h1>
                        <p>Crossing 5, 15, 20, 50, or 100 employees triggers new obligations under federal and state law — from harassment training to ADA, FMLA, and ACA. We map the policies you need at your current size so you don't trip a threshold you didn't know existed.</p>
                        <img src={establishRelationships} alt='Growing Past a Headcount Threshold?'/>
                    </div>
                    <div className='benefitsCard'>
                        <h1>Keeping Up With Legal Change?</h1>
                        <p>State and local employment law changes constantly — paid sick leave, pay transparency, captive-audience bans, AI-in-hiring rules. We track federal, state, and municipal updates so your handbook reflects what's on the books right now, not what was current two years ago.</p>
                        <img src={ensureCompliance} alt='Keeping Up With Legal Change?'/>
                    </div>
                </div>
            </div>
            <div className='howItWorks'>
                <h1>How It Works</h1>
                <h2>A 15-Minute Intake. A State-Aware Handbook.</h2>
                <p>In just 15 minutes, you can fill out our intake to produce a highly personalized manual, representing your business the way you want it while remaining aligned with current federal, state, and local requirements.</p>
                <div className='howItWorksList'>
                    <div className='howItWorksCard'>
                        <div className='howItWorksContainer'>
                            <h1>Step 1</h1>
                            <p>Create your account <button onClick={loginWithRedirect} className='loginButtonHowItWorks'>here</button>.</p>
                        </div>
                    </div>
                    <div className='howItWorksCard'>
                        <div className='howItWorksContainer'>
                            <h1>Step 2</h1>
                            <p>Fill out our intake to produce a highly personalized manual, representing your business the way you want it while remaining aligned with current federal, state, and local requirements.</p>
                        </div>
                    </div>
                    <div className='howItWorksCard'>
                        <div className='howItWorksContainer'>
                            <h1>Step 3</h1>
                            <p>Receive your manual within a day and distribute it to your employees.</p>
                        </div>
                    </div>
                    <div className='howItWorksCard'>
                        <div className='howItWorksContainer'>
                            <h1>Step 4</h1>
                            <p>View our free guides on our blog to support your compliance program and help your business use the manual effectively.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='pricing' id='pricing'>
                <h1>Pricing</h1>
                <p>Our pricing is simple. We charge a flat fee of <b>$525</b> for each manual, with annual revisions costing only <b>$275</b>.</p>
                <button className='getStarted' onClick={loginWithRedirect}>Get Started</button>
            </div>
        </div>
    );
}

export default Home;
